import { muiGlyph } from "@/components/ui/mui-glyph";

// The three glyphs the donor's items toolbar draws.
//
// `items-toolbar.tsx:7-9` imports them from `@mui/icons-material` by these
// exact names — `Settings`, `Delete`, and `Clear` under the local alias
// `DeselectIcon` — and each lands in the tree as an `SvgIcon` at its default
// `fontSize: medium`, a 24px box (`SvgIcon.js:75-78`): the gear as
// `MenuButton`'s `icon`, the other two as a `Button`'s `startIcon`.
//
// Atlas drew lucide's `Settings` / `Trash2` / `X` instead. Those are **stroked
// outlines**; MUI's are **solid fills**, which is a different drawing of the
// same idea rather than the same drawing at a different weight — measured on
// the running pages, `fill: none` against `fill: currentColor`, and 2 and 5
// sub-paths against MUI's 1. The trash and the clear were 20px as well.
//
// The paths are copied byte-for-byte off the running donor's DOM rather than
// retyped, each one the single `<path d>` of its `SvgIcon`.

/** `@mui/icons-material/Settings.js`. */
const SETTINGS_PATH =
  "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6";
/** `@mui/icons-material/Delete.js`. */
const DELETE_PATH = "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z";
/** `@mui/icons-material/Clear.js`, the donor's `DeselectIcon`. */
const CLEAR_PATH =
  "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";

export const MuiSettingsIcon = muiGlyph("mui-settings", SETTINGS_PATH, "size-6");
export const MuiDeleteIcon = muiGlyph("mui-delete", DELETE_PATH, "size-6");
export const MuiClearIcon = muiGlyph("mui-clear", CLEAR_PATH, "size-6");
